import { render } from "./SchedulesPage.vue?vue&type=template&id=78a90aec"
import script from "./SchedulesPage.vue?vue&type=script&lang=ts"
export * from "./SchedulesPage.vue?vue&type=script&lang=ts"
script.render = render

export default script